(function () {
  window.toggleWishlistButton = function (handle, button) {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem('cb-wishlist')) || [];
    } catch (error) {
      list = [];
    }

    const index = list.indexOf(handle);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(handle);
    }

    localStorage.setItem('cb-wishlist', JSON.stringify(list));
    document.querySelectorAll('[data-wishlist-toggle="' + CSS.escape(handle) + '"]').forEach(function (item) {
      const saved = list.includes(handle);
      item.classList.toggle('active', saved);
      item.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    });
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  };

  window.initializeWishlistButtons = function () {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem('cb-wishlist')) || [];
    } catch (error) {
      list = [];
    }

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      const handle = button.getAttribute('data-wishlist-toggle');
      const saved = list.includes(handle);
      button.classList.toggle('active', saved);
      button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initializeWishlistButtons);
  } else {
    window.initializeWishlistButtons();
  }
  document.addEventListener('shopify:section:load', window.initializeWishlistButtons);
})();
